const PaginationData = {
    page: 0,
    size: 10,
    first: true,
    last: true,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 1   
}

export default PaginationData;